import script from "./AppCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCard.vue?vue&type=script&setup=true&lang=js"

import "./AppCard.vue?vue&type=style&index=0&id=8b3ffd18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b3ffd18"]])

export default __exports__